<template>
  <div class="version">{{BUILD_VERSION}}</div>
</template>

<script>
export default {
  computed: {
    BUILD_VERSION: () => BUILD_VERSION
  },

}
</script>

<style lang="scss" scoped>
.version {
  text-align: center;
  font-size: 60%;
  margin-top: 0.2rem;
  color: $gray_70;
}
</style>
